import { escrowCriteriaApi, expressionDefinitionApiV2 } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const ESCROW_REQUIREMENTS_ACTION_TYPE = createNamedActions('escrowRequirements', {
  GET_CRITERIA: 'GET_CRITERIA',
  ADD_CRITERIA: 'ADD_CRITERIA',
  EDIT_CRITERIA: 'EDIT_CRITERIA',
  DELETE_CRITERIA: 'DELETE_CRITERIA',
  GET_SCHEMA_PARAMS: 'GET_SCHEMA_PARAMS',
});

const criteria = new schema.Entity('criteria', {}, { idAttribute: 'criteriaId' });

export const getEscrowRequirementsCriteriaAction = catchAsyncActionError(
  ({ snapshotId }) =>
    async dispatch => {
      const { data } = await escrowCriteriaApi.getEscrowCriteria({ snapshotId });

      return dispatch({
        type: ESCROW_REQUIREMENTS_ACTION_TYPE.GET_CRITERIA,
        payload: normalize(data, [criteria]).entities.criteria,
      });
    },
);

export const addEscrowRequirementsCriteriaAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await escrowCriteriaApi.createEscrowCriteria(params);

    return dispatch({
      type: ESCROW_REQUIREMENTS_ACTION_TYPE.ADD_CRITERIA,
      payload: data,
    });
  },
);

export const editEscrowRequirementsCriteriaAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await escrowCriteriaApi.editEscrowCriteria(params);

    return dispatch({
      type: ESCROW_REQUIREMENTS_ACTION_TYPE.EDIT_CRITERIA,
      payload: data,
    });
  },
);

export const deleteEscrowRequirementsCriteriaAction = catchAsyncActionError(
  ({ criteriaId }) =>
    async dispatch => {
      await escrowCriteriaApi.deleteEscrowCriteria({ criteriaId });

      return dispatch({
        type: ESCROW_REQUIREMENTS_ACTION_TYPE.DELETE_CRITERIA,
        meta: { criteriaId },
      });
    },
);

export const getEscrowRequirementsSchemaParamsAction = catchAsyncActionError(
  () => async dispatch => {
    const { data } = await expressionDefinitionApiV2.getEscrowRequirementsExpressionDefinition();

    return dispatch({
      type: ESCROW_REQUIREMENTS_ACTION_TYPE.GET_SCHEMA_PARAMS,
      payload: data,
    });
  },
);
